/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfileFormValuesDto
 */
export interface ProfileFormValuesDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileFormValuesDto
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFormValuesDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFormValuesDto
     */
    nickname: string;
}

export function ProfileFormValuesDtoFromJSON(json: any): ProfileFormValuesDto {
    return ProfileFormValuesDtoFromJSONTyped(json, false);
}

export function ProfileFormValuesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileFormValuesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fullName': json['fullName'],
        'email': json['email'],
        'nickname': json['nickname'],
    };
}

export function ProfileFormValuesDtoToJSON(value?: ProfileFormValuesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fullName': value.fullName,
        'email': value.email,
        'nickname': value.nickname,
    };
}

